// CalendarView.jsx
import "react-big-calendar/lib/css/react-big-calendar.css";
import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";

const localizer = momentLocalizer(moment);

const CalendarView = ({
  events,
  selectedDate,
  onSelectDate,
  onSelectEvent,
}) => {
  const dayPropGetter = (date) => {
    const isSelected = selectedDate && moment(date).isSame(selectedDate, "day");

    if (isSelected) {
      return {
        style: {
          backgroundColor: "#e2d94e",
          color: "white",
          borderRadius: "4px",
        },
      };
    }
    return {};
  };

  const EventPreview = ({ event }) => {
    return <span>{event.title}</span>;
  };

  return (
    <div className="bg-white dark:bg-gray-800 p-3 rounded shadow relative">
      <Calendar
        localizer={localizer}
        events={events}
        selectable
        defaultView="month"
        defaultDate={new Date()}
        onSelectSlot={onSelectDate}
        onSelectEvent={onSelectEvent}
        dayPropGetter={dayPropGetter}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500 }}
        components={{
          event: EventPreview,
        }}
      />
    </div>
  );
};

export default CalendarView;
